// extracted by mini-css-extract-plugin
module.exports = {"title":"_1QKLF","hc_main":"_1rk52","link":"_7ha1h","specialBtn":"_3JKyM","warnTip":"Gn1EG"};